import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, UserPlus, UserRoundX } from "lucide-react";
import Swal from "sweetalert2";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { useOperador } from "../../Hooks/useOperador";
import { operadorEhAdmin } from "../../Utils/cargos";
import { assinaturaDigitalService } from "../../Services/assinaturaDigital";
import "../AssinaturaDigitalCertificado/styles.css";
import "./styles.css";

const AssinaturaDigitalControleAcesso = () => {
  const navigate = useNavigate();
  const { IDOperador, nome, operador } = useOperador();
  const [operadores, setOperadores] = useState([]);
  const [selecionado, setSelecionado] = useState("");
  const [busca, setBusca] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [alterando, setAlterando] = useState(false);
  const isAdmin = operadorEhAdmin(operador);

  const carregar = useCallback(async () => {
    try {
      setCarregando(true);
      const dados = await assinaturaDigitalService.listarControleAcesso();
      setOperadores(Array.isArray(dados) ? dados : []);
    } catch (error) {
      Swal.fire("Erro", error.response?.data?.errors?.default ||
        "Nao foi possivel carregar o controle de acesso.", "error");
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => {
    if (!isAdmin) { navigate("/Menu"); return; }
    carregar();
  }, [isAdmin, navigate, carregar]);

  const candidatos = useMemo(() => operadores.filter((item) =>
    item.situacao === 1 && !item.administrador && !item.gerente && !item.autorizado), [operadores]);
  const autorizados = useMemo(() => operadores.filter((item) =>
    item.autorizado && !item.administrador &&
    `${item.nome} ${item.email} ${item.IDOperador}`.toLowerCase().includes(busca.toLowerCase())),
  [operadores, busca]);

  const alterar = async (id, autorizado) => {
    if (!id || alterando) return;
    if (!autorizado) {
      const confirmacao = await Swal.fire({
        title: "Retirar acesso a Fila?",
        text: "O operador perdera imediatamente a permissao de visualizar e assinar documentos.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Retirar acesso",
        cancelButtonText: "Cancelar",
      });
      if (!confirmacao.isConfirmed) return;
    }
    try {
      setAlterando(true);
      await assinaturaDigitalService.definirAcessoFila(Number(id), autorizado);
      setSelecionado("");
      await carregar();
      Swal.fire("Sucesso", autorizado ? "Acesso concedido." : "Acesso retirado.", "success");
    } catch (error) {
      Swal.fire("Erro", error.response?.data?.errors?.default ||
        "Nao foi possivel atualizar o acesso.", "error");
    } finally {
      setAlterando(false);
    }
  };

  return (
    <div className="menu-container-menu certificado-page">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <div className="page-shell certificado-shell">
          <MenuSuperior userId={String(IDOperador).padStart(6, "0")} userName={nome} />
          <section className="certificado-header">
            <div>
              <span><KeyRound size={17} /> Assinatura Digital</span>
              <h1>Controle de Acesso</h1>
            </div>
            <button type="button" onClick={() => navigate("/AssinaturaDigital/Certificado")}>Voltar aos certificados</button>
          </section>
          <section className="controle-acesso-card">
            <h2>Autorizar operador</h2>
            <p>A autorizacao vale para toda a Fila de Assinatura. Apenas o ADM pode concede-la ou retira-la. Gerentes nao podem ser autorizados.</p>
            <div className="controle-acesso-form">
              <select aria-label="Operador a autorizar" value={selecionado}
                onChange={(event) => setSelecionado(event.target.value)} disabled={carregando || alterando}>
                <option value="">Selecione um operador ativo</option>
                {candidatos.map((item) => (
                  <option key={item.IDOperador} value={item.IDOperador}>
                    {item.nome} (#{item.IDOperador}){item.email ? ` - ${item.email}` : ""}
                  </option>
                ))}
              </select>
              <button type="button" onClick={() => alterar(selecionado, true)}
                disabled={!selecionado || alterando || carregando}>
                <UserPlus size={17} /> Adicionar
              </button>
            </div>
          </section>
          <section className="controle-acesso-card">
            <div className="controle-acesso-heading">
              <div>
                <h2>Operadores autorizados</h2>
                <p>Administradores ja possuem acesso pelo cargo e nao aparecem nesta lista.</p>
              </div>
              <input aria-label="Buscar operador autorizado" placeholder="Buscar operador" value={busca}
                onChange={(event) => setBusca(event.target.value)} />
            </div>
            {carregando && <p>Carregando operadores...</p>}
            {!carregando && autorizados.length === 0 && <p>Nenhum operador autorizado encontrado.</p>}
            {!carregando && autorizados.map((item) => (
              <div className="controle-acesso-linha" key={item.IDOperador}>
                <div>
                  <strong>{item.nome} (#{item.IDOperador})</strong>
                  <small>{item.email || "Sem e-mail"}{item.situacao !== 1 ? " - Operador inativo" : ""}{item.gerente ? " - Gerente: acesso bloqueado; retire esta autorizacao antiga" : ""}</small>
                </div>
                <button type="button" onClick={() => alterar(item.IDOperador, false)} disabled={alterando}>
                  <UserRoundX size={17} /> Retirar acesso
                </button>
              </div>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
};

export default AssinaturaDigitalControleAcesso;
